import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

export type OAuthSlice = {
  accessToken: string | null;
  refreshToken: string | null;
  isLoggedIn?: boolean;
};

const initialState: OAuthSlice = {
  accessToken: null,
  refreshToken: null
};

export const oAuthSlice = createSlice({
  name: 'oAuth',
  initialState,
  reducers: {
    setOAuth: (state, action: PayloadAction<OAuthSlice>) => {
      const { accessToken, refreshToken } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
    }
  }
});

const selectOAuth = (state) => state.oAuth;

export const selectAccessToken = createSelector(selectOAuth, (oAuth) => oAuth.accessToken);

export const selectRefreshToken = createSelector(selectOAuth, (oAuth) => oAuth.refreshToken);

export const selectIsLoggedIn = createSelector(selectOAuth, (oAuth) => !!oAuth.refreshToken || !!oAuth.accessToken);

export const { setOAuth } = oAuthSlice.actions;
